import { render, staticRenderFns } from "./BxInput.vue?vue&type=template&id=d235eeda&"
import script from "./BxInput.vue?vue&type=script&lang=js&"
export * from "./BxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports